import { Button, Css, ModalBody, ModalFooter, ModalHeader, useModal } from "@homebound/beam";
import { PlanPackageAiProposalWorkflow } from "src/generated/graphqlTypes";
import { useNavigateToRpav } from "src/hooks/useNavigateToRpav";
import { useRouteParams } from "src/hooks/useRouteParams";
import {
  ConstructionDocumentPicker,
  useConstructionDocumentPicker,
} from "src/routes/libraries/plan-package-v2/components/ConstructionDocumentPicker";
import { useCreatePlanPackageAiProposalMutation } from "src/routes/libraries/plan-package-v2/components/overview/PlanPackageDocumentImportPanel.generated";
import { PlanPackageDetailsParams } from "src/routes/routesDef";

export function GenerateTakeoffModal() {
  const { planPackageId, planPackageVersionId } = useRouteParams<PlanPackageDetailsParams>();
  const { closeModal } = useModal();
  const navigateToRpav = useNavigateToRpav();
  const [createProposal] = useCreatePlanPackageAiProposalMutation();
  const picker = useConstructionDocumentPicker(async (asset) => {
    const { data } = await createProposal({
      variables: { input: { planPackageId, asset, workflow: PlanPackageAiProposalWorkflow.GenerateTakeoff } },
    });
    closeModal();
    // Uploading onto a published version forks a draft to hold the new document, so follow it there
    const draftId = data?.createPlanPackageAiProposal.planPackage.aggregateDraft?.id;
    if (!asset.id && draftId && draftId !== planPackageVersionId) navigateToRpav(draftId);
  });

  return (
    <>
      <ModalHeader>Generate Lines of Scope</ModalHeader>
      <ModalBody>
        <div css={Css.df.fdc.gap3.$}>
          <p>
            Lines of scope are generated using this plan's current program data, options, locations, construction
            documents, and comparable plans.
          </p>
          <ConstructionDocumentPicker picker={picker} />
        </div>
      </ModalBody>
      <ModalFooter>
        <Button label="Cancel" variant="text" onClick={closeModal} />
        <Button
          label="Generate Lines"
          variant="ai"
          disabled={picker.missing || (picker.submitting && "Generating...")}
          onClick={picker.submit}
        />
      </ModalFooter>
    </>
  );
}
